import React from 'react'

import Brandy from '../../Brandy'
import Price from '../../Price'
import Bullets from '../Bullets'
import Details from '../Details'
import Label from '../Labelv2'
import MainContent from '../MainContent'
import NameAndDescription from '../NameAndDescription'
import * as Styled from './HorizontalPackageCard.styles'

const HorizontalPackageCard = ({
  content = null,
  image = null,
  labelData = null,
  modal = null,
  packageData,
}) => {
  const hasImage = Boolean(image?.props?.data)
  const numberOfColumns =
    [Boolean(packageData?.bullets), hasImage]?.filter(Boolean)?.length + 1

  return (
    <Styled.PackageCard
      className="wrapper"
      numberOfColumns={numberOfColumns}
      hasImage={hasImage} // Change the grid on tablet since we're hiding image on tablet
    >
      {labelData?.text && (
        <Label
          text={labelData.text}
          labelType="contentfulLabel"
          smallSpacing
          noPositionStyles
        />
      )}
      <Styled.Grid numberOfColumns={numberOfColumns} hasImage={hasImage}>
        <Styled.Column className="column-1">
          <NameAndDescription
            name={packageData.name}
            description={packageData.description}
          />

          <Details packageData={packageData.details} />

          {packageData?.price?.amount && (
            <Price
              className="price"
              {...packageData?.price}
              inPackageCard
              priceOld={packageData?.priceOld}
              nutrition={packageData?.nutrition}
            />
          )}
          {packageData?.price?.custom && (
            <Styled.CustomTextContainer>
              <Styled.CustomText inPackageCard>
                {packageData?.price?.custom}
              </Styled.CustomText>
              {packageData?.price?.disclaimer && (
                <Brandy
                  className="bullet-disclaimer"
                  symbol={packageData.price?.disclaimer?.symbol}
                  text={packageData.price?.disclaimer?.text}
                  variant="legal"
                />
              )}
            </Styled.CustomTextContainer>
          )}
          {modal && <span className="modal">{modal}</span>}
          <MainContent content={content} />
        </Styled.Column>
        {Boolean(packageData?.bullets) && (
          <Styled.Column className="column-2">
            <Bullets bullets={packageData?.bullets} />
          </Styled.Column>
        )}
        {hasImage && (
          <Styled.Column className="column-3">
            <div className="desktop-image">{image}</div>
          </Styled.Column>
        )}
      </Styled.Grid>{' '}
    </Styled.PackageCard>
  )
}

/* eslint-enable react/no-danger */
export default HorizontalPackageCard
